module.exports = __webpack_public_path__ + "assets/img/ee61-az.svg";